import CardHeader from "components/CardHeader";
import React, {useEffect, useMemo, useState} from "react";
import {Card, CardBody, Col, Row} from "reactstrap";
import {connect} from "react-redux";
import {getUsers} from "store/actions/Users";
import {bindActionCreators} from "redux";
import {RootState} from "../../store/store";
import UserProfilesTable from "./UserProfilesTable";
import PageMeta from "components/PageMeta";
import {UsersState} from 'store/reducers/Users';
import { Link } from "react-router-dom";
import { useOfficeTranslation } from "i18n/OfficeTranslation";

interface Props {
  usersState: UsersState;
}

interface Actions {
  getUsers: () => void;
}

const UserProfiles: React.FC<Actions & Props> = ({ usersState, getUsers }) => {
  const { t } = useOfficeTranslation();
  const [query, setQuery] = useState("");

  useEffect(() => {
    getUsers()
  }, [getUsers])

  const visibleUsers = useMemo(() => {
    const keyword = query.trim().toLowerCase();

    return usersState.getUsers()
      .filter(user =>
        user.name.toLowerCase().includes(keyword)
        || user.email.toLowerCase().includes(keyword)
        || user.region.toLowerCase().includes(keyword)
      )
      .sort((a, b) => a.name.localeCompare(b.name));
  }, [query, usersState]);

  return (
    <div className="page-content">
      <PageMeta title={t("common.users")} />

      <div className="page-title-box d-flex justify-content-between align-items-center flex-wrap gap-3">
        <div>
          <h4 className="mb-1">{t("common.users")}</h4>
          <p className="text-muted mb-0">{t("user.userProfiles.accessActivationAndRegionalSettings")}</p>
        </div>
        <Link to="/users/add" className="btn btn-primary">
          <i className="mdi mdi-plus me-1" />
          {t("common.addUser")}
        </Link>
      </div>

      <Card>
        <CardBody>
          <CardHeader
            title={t("user.userProfiles.userOverview")}
            icon="mdi-account-multiple-outline"
            count={visibleUsers.length}
          />

          <Row className="g-3 py-3 border-bottom">
            <Col md={5}>
              <div className="position-relative">
                <input
                  aria-label={t("user.userProfiles.searchUsers")}
                  className="form-control ps-5"
                  placeholder={t("user.userProfiles.searchNameEmailOrRegion")}
                  value={query}
                  onChange={event => setQuery(event.target.value)}
                />
                <i
                  className="mdi mdi-magnify position-absolute text-muted font-size-20"
                  style={{ left: 16, top: 7 }}
                />
              </div>
            </Col>
          </Row>

          <UserProfilesTable users={visibleUsers} />
        </CardBody>
      </Card>
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    usersState: state.Users
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return bindActionCreators({ getUsers }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(UserProfiles);
